// hooks/useSelectUser.js
import { useQuery } from "@tanstack/react-query";
import usersAPI from "features/Setting/users/api/userApis";
import apiClient from "lib/api-client";
import { getUserDetail } from "utils/getUserDetailsHelper";

export const useSelectUser = () =>
  useQuery({
    queryKey: ['RateMasterRights'],
    queryFn: usersAPI.getAllUserData,
    cacheTime: 200000,
    staleTime: 20000,
    refetchOnWindowFocus: true,
  });

// ------------------------------  Update Rate Master ----------------------------- //

  export const updateRateMaster = async (payload) => {
    let response = await apiClient.post(`/api/v1/rateMaster`, payload);
    return response.data;
  };

// ------------------------------  Get Rate Master ----------------------------- //

  export const getSpecificRates = async (User) => {
    let response = await apiClient.get(`/api/v1/rateMaster?userId=${User}`);
    return response.data;
  };

export const getRateMasterChartData = async () => {
  try {
  let response = await apiClient.get(`/api/v1/rateMaster/getRateMasterData`);
  return response.data.data;
  } catch (error) {
    console.log("There was a error",error)
  }
};

export const useRateMasterChartData = () => {
  return useQuery({
    queryKey: ["RateMasterChartData"],
    queryFn: getRateMasterChartData,
    staleTime: 12000,
  });
};